import {
    GameActionEnum,
    SetBattleBg,
    SetCountersAction,
    SetCpuAction, SetCpuDataAction,
    SetCpuDiamondAction,
    SetCpuFireAction,
    SetCpuHpAction,
    SetCpuPlayedCardAction,
    SetCpuPowAction,
    SetCpuTableAction,
    SetEndGameAction,
    SetGameAction,
    SetGamePvPDataAction, SetIsLoading,
    SetIsPlaySpellDrag,
    SetIsPvPAction,
    SetMessageAction,
    SetPhaseAction,
    SetPlayedCardAction,
    SetPlayerADAction,
    SetPlayerDiamondAction,
    SetPlayerFireAction,
    SetPlayerHandAction,
    SetPlayerHpAction,
    SetPlayerMulliganAction,
    SetPlayerPowAction,
    SetPlayerTableAction,
    SetPlayerTurnAction,
    SetTouchDragCoords
} from "./types";

import {AppDispatch, store} from "../../index";
import {AuthActionCreators} from "../auth/action-creators";
import GameService from "../../../api/GameService";
import {IPlayedCard} from "../../../models/game/IPlayedCard";
import ServerStateDispatcher from "../../../services/states/ServerStateDispatcher";
import {SoundsService} from "../../../services/SoundsService";


export const GameActionCreators = {
    setCpu: (activeCpu): SetCpuAction => ({type: GameActionEnum.SET_CPU, payload: activeCpu}),
    setCpuData: (cpuData): SetCpuDataAction => ({type: GameActionEnum.SET_CPU_DATA, payload: cpuData}),
    setGame: (game): SetGameAction => ({type: GameActionEnum.SET_GAME, payload: game}),
    setGamePvPData: (gamePvPData): SetGamePvPDataAction => ({
        type: GameActionEnum.SET_GAME_PVP_DATA,
        payload: gamePvPData
    }),
   setPhase: (phase): SetPhaseAction => ({type: GameActionEnum.SET_PHASE, payload: phase}),

    setPlayerFire: (playerFire): SetPlayerFireAction => ({type: GameActionEnum.SET_PLAYER_FIRE, payload: playerFire}),
    setPlayerDiamond: (playerDiamond): SetPlayerDiamondAction => ({
        type: GameActionEnum.SET_PLAYER_DIAMOND,
        payload: playerDiamond
    }),
    setPlayerPow: (playerPow): SetPlayerPowAction => ({type: GameActionEnum.SET_PLAYER_POW, payload: playerPow}),
    setPlayerHp: (playerHp): SetPlayerHpAction => ({type: GameActionEnum.SET_PLAYER_HP, payload: playerHp}),
    setPlayerHand: (playerHand): SetPlayerHandAction => ({type: GameActionEnum.SET_PLAYER_HAND, payload: playerHand}),
    setPlayerTable: (playerTable): SetPlayerTableAction => ({
        type: GameActionEnum.SET_PLAYER_TABLE,
        payload: playerTable
    }),
    setPlayerAD: (playerAD): SetPlayerADAction => ({type: GameActionEnum.SET_PLAYER_AD, payload: playerAD}),
    setPlayerTurn: (playerTurn): SetPlayerTurnAction => ({type: GameActionEnum.SET_PLAYER_TURN, payload: playerTurn}),
    setPlayerMulligan: (playerMulligan): SetPlayerMulliganAction => ({type: GameActionEnum.SET_PLAYER_MULLIGAN, payload: playerMulligan}),

    setCpuFire: (cpuFire): SetCpuFireAction => ({type: GameActionEnum.SET_CPU_FIRE, payload: cpuFire}),
    setCpuDiamond: (cpuDiamond): SetCpuDiamondAction => ({type: GameActionEnum.SET_CPU_DIAMOND, payload: cpuDiamond}),
    setCpuPow: (cpuPow): SetCpuPowAction => ({type: GameActionEnum.SET_CPU_POW, payload: cpuPow}),
    setCpuHp: (cpuHp): SetCpuHpAction => ({type: GameActionEnum.SET_CPU_HP, payload: cpuHp}),
    setCpuTable: (cpuTable): SetCpuTableAction => ({type: GameActionEnum.SET_CPU_TABLE, payload: cpuTable}),

    setPlayedCard: (playedCard): SetPlayedCardAction => ({type: GameActionEnum.SET_PLAYED_CARD, payload: playedCard}),
    setCpuPlayedCard: (cpuPlayedCard): SetCpuPlayedCardAction => ({
        type: GameActionEnum.SET_CPU_PLAYED_CARD,
        payload: cpuPlayedCard
    }),

    setEndGame: (endGame): SetEndGameAction => ({
        type: GameActionEnum.SET_END_GAME,
        payload: endGame
    }),
    setMessage: (message): SetMessageAction => ({
        type: GameActionEnum.SET_MESSAGE,
        payload: message
    }),
    setIsPvP: (isPvP): SetIsPvPAction => ({
        type: GameActionEnum.SET_IS_PVP,
        payload: isPvP
    }),
    setCounters: (counters): SetCountersAction => ({
        type: GameActionEnum.SET_COUNTERS,
        payload: counters
    }),
    setIsPlaySpellDrag: (isPlaySpellDrag): SetIsPlaySpellDrag => ({
        type: GameActionEnum.SET_IS_PLAY_SPELL_DRAG,
        payload: isPlaySpellDrag
    }),
    setTouchDragCoords: (touchDragCoords): SetTouchDragCoords => ({
        type: GameActionEnum.SET_TOUCH_DRAG_COORDS,
        payload: touchDragCoords
    }),
    setBattleBg: (battleBg:string): SetBattleBg => ({
        type: GameActionEnum.SET_BATTLE_BG,
        payload: battleBg
    }),
    setIsBattleLoading: (isLoading:boolean): SetIsLoading => ({
        type: GameActionEnum.SET_IS_BATTLE_LOADING,
        payload: isLoading
    }),
    processState: async function (serverState, dispatch: AppDispatch, hardResetQueue: boolean = false): Promise<void> {

        await ServerStateDispatcher.processState(serverState, dispatch, hardResetQueue);

    },
    processPvPGame: (data: any) => async (dispatch: AppDispatch) => {

        await GameActionCreators.processState(data, dispatch);

    },
    startGame: (cpuId: number) => async (dispatch: AppDispatch) => {
        dispatch(AuthActionCreators.setIsLoading(true));

        dispatch(GameActionCreators.setEndGame({winner: null, result: null}));

        try {
            const response = await GameService.startGame(cpuId);
            await GameActionCreators.processState(response.data, dispatch);
        } catch (e) {
            console.log('start game error');
        }

        dispatch(AuthActionCreators.setIsLoading(false));
    },

    playCard: (playedCard: IPlayedCard) => async (dispatch: AppDispatch) => {
        dispatch(AuthActionCreators.setIsLoading(true));

        if(playedCard.card?.type_card === 'unit') {
            SoundsService.playCard(playedCard.card, playedCard.handKey,);
        }

        try {
            const response = await GameService.playCard(playedCard);
            await GameActionCreators.processState(response.data, dispatch);
        } catch (e) {
            console.log('play card error');
        }

        dispatch(AuthActionCreators.setIsLoading(false));

        // Tutorial battle step
        const state = store.getState();
        let tutorial = state.auth.tutorial;
        if (tutorial.isActive === false) {
            return;
        }

        if (tutorial.step === 'PlayFirstCard40') {
            tutorial.step = 'EndTurnBattle45';
        }
        if (tutorial.step === 'PlaySecondCard50') {
            tutorial.step = 'EndTurnBattle55';
        }

        AuthActionCreators.setTutorial(tutorial);
        ///
    },
    makeMilligan: () => async (dispatch: AppDispatch) => {
        dispatch(AuthActionCreators.setIsLoading(true));

        try {
            const response = await GameService.makeMulligan();
            await GameActionCreators.processState(response.data, dispatch);
        } catch (e) {
            // @ts-ignore
            console.log('mulligan error ' + e.message);
        }

        dispatch(AuthActionCreators.setIsLoading(false));
    },
    playerGiveUp: () => async (dispatch: AppDispatch) => {
        dispatch(AuthActionCreators.setIsLoading(true));

        try {
            const response = await GameService.giveUp();
            await GameActionCreators.processState(response.data, dispatch, true);
        } catch (e) {
            // @ts-ignore
            console.log('give up error ' + e.message);
        }

        dispatch(AuthActionCreators.setIsLoading(false));
    },
    endTurn: (handKey = null) => async (dispatch: AppDispatch) => {
        dispatch(AuthActionCreators.setIsLoading(true));

        const state = store.getState();

        // Tutorial

        let tutorial = state.auth.tutorial;
        if (tutorial.isActive === true) {

            tutorial.isActive = false;
            AuthActionCreators.setTutorial(tutorial);
        }

        // tutorial end


        if (Object.keys(state.game.playerHand).length > 6 && handKey === null) {

            dispatch(GameActionCreators.setPhase('discard_card'));

            dispatch(GameActionCreators.setMessage({text: 'Discard a card!', delay: 3000, type: 'discard'}));

            dispatch(AuthActionCreators.setIsLoading(false));
            return;
        }


        dispatch(GameActionCreators.setPhase('enemy_turn'));

        try {
                const response = await GameService.endTurn(handKey);
                await GameActionCreators.processState(response.data, dispatch); // showCpuTurn

        } catch (e) {
            // @ts-ignore
            console.log('end turn error ' + e.message);
        }

        dispatch(AuthActionCreators.setIsLoading(false));

    }
}
